import { coalesceLocaleField } from '../helpers/coalesceLocaleField'
import { groq } from 'next-sanity'
import { LocaleId } from '@sans-souci/configs'
import { createLinkProjection } from '../projections/createLinkProjection'
import { createMediaProjection } from '../projections/createMediaProjection'

export const createSectionPhilosophySliderProjection = (localeId: LocaleId) => {
  const LINK_PROJECTION = createLinkProjection(localeId)
  const MEDIA_PROJECTION = createMediaProjection(localeId)

  return groq`{
    _key,
    _type,
    ${coalesceLocaleField('title', localeId)},
      slides[]{
      ${coalesceLocaleField('title', localeId)},
      ${coalesceLocaleField('text', localeId)},
      color,
      image${MEDIA_PROJECTION},
      ctaLink${LINK_PROJECTION}
    }
  }
  `
}
